import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CustomToolbarAction, convertCamelCaseToTitleCase } from 'utils';
import type { ResourceTableService } from '../../../_services/resource-table.service';
import { AsyncPipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CtxButtonComponent } from '../../button/button.component';
import { HlmIconComponent } from '../../icon';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'table-toolbar',
  templateUrl: './toolbar.component.html',
  standalone: true,
  imports: [
    CtxButtonComponent,
    MatFormFieldModule,
    HlmIconComponent,
    MatInputModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
})
export class CtxTableToolbarComponent implements OnInit {
  /**
   * Ref to ResourceTableService
   */
  @Input() resourceTableService: ResourceTableService;

  /**
   * FormControl object to manage state for the search bar. Although using a reactive form
   * for one input seems like overkill, we are already importing ReactiveFormsModule in this
   * Module and using FormsModule for this one use would be a bigger issue.
   */
  searchControl: FormControl;

  /**
   * Define funciton as property to use in the template
   */
  convertCamelCaseToTitleCase = convertCamelCaseToTitleCase;

  ngOnInit() {
    /** Initialize the searchControl property */
    this.searchControl = new FormControl({
      value: this.resourceTableService.tableSearch.query,
      disabled: !this.resourceTableService.readAllowed,
    });
  }

  /**
   * Set the 'query' QueryParam in the Web API request using the ResourceTableService
   * AND refresh the table data.
   */
  async search() {
    this.resourceTableService.tableSearch = { query: this.searchControl.value };
    await this.resourceTableService.tableList();
  }

  /**
   * Set the search 'query' to empty string
   */
  async clearSearch() {
    this.searchControl.patchValue('');
    await this.search();
  }

  get creationLabel() {
    if (
      this.resourceTableService.resourceName === 'activation' ||
      this.resourceTableService.resourceName === 'trial'
    ) {
      return 'Create Offline';
    } else {
      return 'Create';
    }
  }

  get isSelected() {
    return !this.resourceTableService.selections.isEmpty();
  }

  callCustomAction(action: CustomToolbarAction) {
    if (action.isBulkOperation) {
      action.callback(this.resourceTableService.selections.selected);
    } else {
      action.callback();
    }
  }
}
